import hashUtils from 'app-lib/hashUtils'
import { ChainId } from 'bzx-common/src/config/appConfig'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { Button, Icon } from 'ui-framework'
import RootStore from '../../stores/RootStore'
import ExternalLink from '../ExternalLink'

const chevronDown = (
  <Icon name="caret-down" bgCircle bgColor="#00000022" bgPadding={6} size={20} top={1} />
)
const closeIcon = <Icon name="cross" bgCircle bgColor="#00000022" bgPadding={6} size={20} top={1} />

const logos: Record<ChainId, React.ReactNode> = {
  1: <Icon name="ethereum-logo" size={20} />,
  10: <Icon name="chain-optimism" size={20} />,
  56: <Icon name="binance-logo" color="#f3ba2e" size={20} />,
  137: <Icon name="polygon-logo" size={20} />,
  42161: <Icon name="arbitrum-logo" size={20} />,
}

/**
 * TODO move to dateUtils
 */
function formatDate(timestamp = 0) {
  return new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}

export function TransactionTracker(props: any) {
  const rootStore = props.rootStore as RootStore
  const { transactionStore } = rootStore
  const { transactions, collapsed } = transactionStore
  const cssClass =
    transactions.length === 0
      ? 'tx-tracker'
      : collapsed
      ? 'tx-tracker--collapsed'
      : 'tx-tracker--visible'
  return (
    <div className={cssClass}>
      <Button
        variant="white"
        className="tx-tracker__toggle"
        onClick={transactionStore.toggle}
        onClickEmit="name-value"
        name="collapsed">
        <span className="margin-right-1">TX</span>
        {transactionStore.collapsed ? (
          <span className="tx-tracker__count">{transactionStore.transactions.length}</span>
        ) : (
          chevronDown
        )}
      </Button>
      <table className="table--narrow border-collapse">
        {transactions.map((tx) => {
          const statusClass = tx.status === 'failed' ? 'txt-red-aim' : 'txt-green-aim'
          const hashContent = tx.hash ? (
            <ExternalLink className="link" href={`${tx.scannerLink}`}>
              {hashUtils.shortHash(tx.hash)}
            </ExternalLink>
          ) : tx.error ? (
            '-'
          ) : (
            'pending...'
          )

          return (
            <React.Fragment key={tx.time}>
              <tbody key={tx.time} className="tx-tracker__transaction">
                <tr>
                  <td>{logos[tx.chainId]}</td>
                  <td className={statusClass}>
                    <b className="txt-capitalize flex-row-center">
                      {tx.status}
                      {tx.status === 'mining' && (
                        <img
                          className="margin-left-1ch"
                          height="20"
                          src="/gif/ooki-mining-black.gif"
                        />
                      )}
                    </b>
                  </td>
                  <td>{tx.type}</td>
                  <td>
                    <i>{hashContent}</i>
                  </td>
                  <td>{formatDate(tx.time)}</td>
                  <td className="txt-right">
                    <Button
                      variant="invisible"
                      size="auto"
                      onClick={transactionStore.removeTx}
                      onClickEmit="value"
                      value={tx}>
                      {closeIcon}
                    </Button>
                  </td>
                </tr>
                {tx.error && (
                  <tr>
                    <td colSpan={6}>
                      {!tx.error.noError && (
                        <textarea
                          className="tx-tracker__error"
                          defaultValue={tx.error.stackMessages}
                          readOnly={true}
                        />
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </React.Fragment>
          )
        })}
      </table>
    </div>
  )
}

export default inject('rootStore')(observer(TransactionTracker))
